(function () {
  const STORAGE_KEY = 'heritage_popup_dismissed';

  function init() {
    const popup = document.querySelector('[data-heritage-popup]');
    if (!popup) return;

    if (sessionStorage.getItem(STORAGE_KEY) === '1') return;

    const delay = parseInt(popup.dataset.delay, 10) * 1000 || 3000;
    const closers = popup.querySelectorAll('[data-heritage-popup-close]');

    closers.forEach((el) => el.addEventListener('click', closePopup));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });

    const addBtn = popup.querySelector('[data-heritage-popup-add]');
    if (addBtn) addBtn.addEventListener('click', handleAddToCart);

    const signupForm = popup.querySelector('[data-heritage-signup-form]');
    if (signupForm) signupForm.addEventListener('submit', handleSignup);

    setTimeout(openPopup, delay);
    startCountdown(popup);

    function openPopup() {
      popup.hidden = false;
      requestAnimationFrame(() => popup.classList.add('is-open'));
      popup.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('heritage-popup-open');
    }

    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('heritage-popup-open');
      sessionStorage.setItem(STORAGE_KEY, '1');
      setTimeout(() => {
        popup.hidden = true;
      }, 300);
    }

    async function handleAddToCart(e) {
      e.preventDefault();
      const btn = e.currentTarget;
      const variantId = btn.dataset.variantId;
      const redirect = btn.dataset.redirect || '/cart';
      const errorEl = popup.querySelector('[data-heritage-popup-error]');

      if (!variantId) return;

      btn.classList.add('is-loading');
      btn.disabled = true;
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
          },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          }),
        });

        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.description || data.message || 'Could not add to cart.');
        }

        sessionStorage.setItem(STORAGE_KEY, '1');
        window.location.href = redirect;
      } catch (err) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        if (errorEl) {
          errorEl.textContent = err.message || 'Something went wrong. Please try again.';
          errorEl.hidden = false;
        }
      }
    }

    async function handleSignup(e) {
      e.preventDefault();
      const form = e.currentTarget;
      const button = form.querySelector('.heritage-popup__signup-button');
      const errorEl = form.querySelector('[data-heritage-signup-error]');
      const successEl = form.querySelector('[data-heritage-signup-success]');

      if (errorEl) errorEl.hidden = true;
      if (successEl) successEl.hidden = true;
      if (button) {
        button.disabled = true;
        button.classList.add('is-loading');
      }

      try {
        const res = await fetch(form.action, {
          method: 'POST',
          headers: { Accept: 'text/html' },
          body: new FormData(form),
        });

        if (!res.ok) throw new Error('Signup failed.');

        const html = await res.text();
        if (/customer.*(error|invalid)/i.test(html) && !/posted_successfully/i.test(html)) {
          throw new Error('Please enter a valid email address.');
        }

        form.querySelector('[name="contact[email]"]').value = '';
        if (successEl) successEl.hidden = false;
        form.querySelector('.heritage-popup__signup-input').disabled = true;
      } catch (err) {
        if (errorEl) {
          errorEl.textContent = err.message || 'Something went wrong. Please try again.';
          errorEl.hidden = false;
        }
      } finally {
        if (button) {
          button.disabled = false;
          button.classList.remove('is-loading');
        }
      }
    }
  }

  function startCountdown(popup) {
    const countdownEl = popup.querySelector('[data-heritage-countdown]');
    if (!countdownEl) return;

    const date = popup.dataset.launchDate;
    const time = popup.dataset.launchTime || '00:00';
    if (!date) return;

    const target = new Date(`${date}T${time}:00`).getTime();
    if (isNaN(target)) return;

    const daysEl = countdownEl.querySelector('[data-days]');
    const hoursEl = countdownEl.querySelector('[data-hours]');
    const minutesEl = countdownEl.querySelector('[data-minutes]');
    const secondsEl = countdownEl.querySelector('[data-seconds]');

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      const diff = target - Date.now();
      if (diff <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        clearInterval(timer);
        return;
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);
      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    tick();
    const timer = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
